<template>
  <div class="card">
    <slot />
  </div>
</template>

<style>
.card {
  padding: 1rem 0;
  margin: 0 auto 2rem;
  width: 100%;
  border-radius: 0.5rem;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 0 #0000;
}
</style>
